module.exports = __webpack_public_path__ + "img/weibo.720c07cf.svg";